import { SalesByItemReportTableAccessor } from '../../../../../../../enums/salesByItemReportTableAccessor'
import { SalesOverviewReportTableAccessor } from '../../../../../../../enums/salesOverviewReportTableAccessor'

export const salesReportCurrencyColumnsAccessors: string[] = [
  SalesOverviewReportTableAccessor.GrossTotal,
  SalesOverviewReportTableAccessor.NetTotal,
  SalesOverviewReportTableAccessor.TaxTotal,
  SalesByItemReportTableAccessor.GrossTotal,
  SalesByItemReportTableAccessor.NetTotal,
]
